import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import "../../../../css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
const ItemLocationTabResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "23041e10-d5e4-42ab-81e8-e57b9d88e45b";
       const [currentLayout, setCurrentLayout]= useState("Default");
    const saveState = useCallback((state) => {GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
             ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <FilterRow visible={true} />
                
                <Column dataField="warehouse" caption="Warehouse Location" />
                <Column dataField="locationcode" caption="Location" />
                <Column dataField="description" caption="Description" />         
                <Column dataField="oN_HAND" caption="On Hand" format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true 
                    }} />
                <Column dataField="iN_RECEIVING" caption="In Receiving" format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true 
                    }} />
                <Column dataField="ouT_SHIPPED"  format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true 
                    }} caption="In Shipping" />
                <Column dataField="available"  format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true 
                    }} caption="Available" />
                <Column dataField="iN_ORDERED"  format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true 
                    }} caption="Pending Rec" />
                <Column dataField="ouT_ORDERED"  format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true 
                    }} caption="Pending Ship"/>
                <Column dataField="netavailable"  format={{
                        type: 'fixedPoint',
                        precision: 2,
                        useGrouping: true 
                    }} caption="Net Available" />

                <Column dataField="creationDateTime_Loc" caption="Creation DateTime" dataType="date" visible={false} />
                <Column dataField="lastUpdateDateTime_Loc" caption="Last Update DateTime" dataType="date" visible={false} />
                <Column dataField="creationUserID_Loc" caption="Creation User ID" visible={false} />
                <Column dataField="lastUpdateUserID_Loc" caption="Last Update User ID" visible={false} />
                 <Column dataField="ouT_ORDERED" caption="Out Ordered" visible={false} />                          
                <Column dataField="iN_BACKORDER" caption="In Backorder" visible={false} />
                <Column dataField="ouT_BACKORDER" caption="Out Backorder" visible={false} />
                <Column dataField="iN_UNAVAILABLE" caption="In Unavailable" visible={false} />
                <Column dataField="ouT_UNAVAILABLE" caption="Out Unavailable" visible={false} />
                <Column dataField="iN_FUTURE" caption="In Future" visible={false} />
                <Column dataField="ouT_FUTURE" caption="Out Future" visible={false} />
                <Column dataField="priority" caption="Priority" visible={false} />                
                <Column dataField="height" caption="Height" visible={false} />
                <Column dataField="width" caption="Width" visible={false} />
                <Column dataField="depth" caption="Depth" visible={false} />
                <Column dataField="capacityarea" caption="Capacity Area" visible={false} />
                <Column dataField="capacityvolume" caption="Capacity Volume" visible={false} />
                <Column dataField="capacityunits" caption="Capacity Units" visible={false} />
                <Column dataField="capacitypieces" caption="Capacity Pieces" visible={false} />
                <Column dataField="capacityshippingunits" caption="Capacity Shipping Units" visible={false} />
                <Column dataField="capacitycontainerunits" caption="Capacity Container Units" visible={false} />
                <Column dataField="capacitygrossweight" caption="Capacity Gross Weight" visible={false} />
                <Column dataField="capacitynetweight" caption="Capacity Net Weight" visible={false} />
                <Column dataField="parentLocation" caption="Parent Location" visible={false} />
                <Column dataField="parentLocationDescription" caption="Parent Location Description" visible={false} />

                <Toolbar>
                <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemLocationTabResult);